export const MAX_SKU_SEARCH_TERMS = 5000;

const HEADER = new Set([
    'sku',
    'skus',
    'ean',
    'eans',
    'barcode',
    'barcodes',
    'name',
    'skuname',
    'sku_name',
    'configsku',
    'config_sku',
    'config',
]);

function normalizeToken(raw) {
    return String(raw || '')
        .trim()
        .replace(/^[\uFEFF]+/, '')
        .replace(/^["']+|["']+$/g, '')
        .trim();
}

export function parseSkuSearchList(text, { max = MAX_SKU_SEARCH_TERMS } = {}) {
    const rawTerms = String(text || '')
        .split(/[\s,;]+/)
        .map(normalizeToken)
        .filter(Boolean);
    const looksLikeList = rawTerms.length > 1;
    const terms = [];
    const seen = new Set();
    let truncated = false;

    for (const term of rawTerms) {
        if (looksLikeList && (term.length < 2 || HEADER.has(term.toLowerCase()))) continue;
        const key = term.toLowerCase();
        if (seen.has(key)) continue;
        seen.add(key);
        if (terms.length >= max) {
            truncated = true;
            break;
        }
        terms.push(term);
    }

    return { terms, truncated };
}
